import MerchantAccountSettingsPage from '../../../components/merchant/settings/account/MerchantAccountSettingsPage'

export default function SettingsAccount() {
  return <MerchantAccountSettingsPage />
}
